import React, { FC, HTMLAttributes, ReactNode, useId } from 'react';
import classNames from '../../utils/classnames';
import './toggle-button.scss';

type ToggleButtonProps = HTMLAttributes<HTMLInputElement> & {
    title: React.JSX.Element | Element | string | ReactNode;
    className?: string;
    id?: number | string;
    checked?: boolean;
    disabled?: boolean;
    name?: string;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    isProcessing?: boolean;
};

const ToggleButton: FC<ToggleButtonProps> = ({
    title,
    className = '',
    disabled = false,
    isProcessing = false,
    ...props
}) => {
    const uniqId = useId();

    props.id = props.id ?? uniqId;

    return (
        <div
            className={classNames('lmp-toggle-button', className, {
                disabled,
                'in-progress': isProcessing
            })}
        >
            <label htmlFor={props.id}>
                <span className='switch'>
                    <input type='checkbox' disabled={disabled || isProcessing} {...props} />
                    <span className='slider round' />
                </span>
                <span>{title}</span>
            </label>
        </div>
    );
};

export default ToggleButton;
